import React from "react";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

import SearchLabels from "../SearchLabels";
import SuggestedFilters from "../SuggestedFilters";
import GeneratingSuggestedFiltersLoader from "../../../CreatorSearchTable/components/GeneratingSuggestedFiltersLoader/GeneratingSuggestedFiltersLoader";

export default function CreatorSearchLabels({
  searchFilters,
  changeFilters,
  suggestedFilters,
  updateBothFilters,
}) {
  const { interests } = useSelector((state) => state.creatorSearchReducer);
  const intl = useIntl();

  return (
    <div className="audience-search__labels">
      <SearchLabels
        intl={intl}
        baseFilters={searchFilters}
        interests={interests}
        changeBaseFilters={changeFilters}
        suggestedFilters={suggestedFilters}
        updateBothFilters={updateBothFilters}
      />
      <SuggestedFilters
        intl={intl}
        baseFilters={searchFilters}
        interests={interests}
        suggestedFilters={suggestedFilters}
        updateBothFilters={updateBothFilters}
      />
      <GeneratingSuggestedFiltersLoader />
    </div>
  );
}
